import request from '@/utils/request.ts'

export const getUserInfo = (data: any) =>
  request({
    url: '/api/info',
    method: 'get',
    data
  })

// export const login = (data: any) =>
//   request({
//     url: '/list/loginin',
//     method: 'post',
//     data: data,
//     headers: {
//       'Content-Type': 'application/json'
//     }
//   })
export const login = (data: any) =>
  request({
    url: '/user/login',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const logout = () =>
  request({
    url: '/api/logout',
    method: 'post'
  })
